import React, { useState } from "react";
import Drawer from "./Drawer/Drawer";

// import BottomTolBar from "../../Components/Navigation/BottomTolBar/BottomTolBar";
// import MainToolBar from "../../Components/Navigation/MainToolBar/MainToolBar";

import classes from "./Layout.module.css";
import LeftBar from "./LeftBar/LeftBar";
import RightBar from "./RightBar/RightBar";
import SmallNavigation from "./SmallNavigation/SmallNavigation";
import AOS from "aos";
import { Container, Row, Col } from "react-bootstrap";
import { useLocation } from "react-router";

const Layout = (props) => {
  const [showBackdrop, setShowBackdrop] = useState(false);
  AOS.init({ once: true });
  const closeBackdrop = () => {
    setShowBackdrop(false);
  };
  const { pathname } = useLocation();

  return props.userEmail ? (
    <>
      <Container fluid className>
        <div
          className={`${classes.DrawerToggler} cursor-pointer`}
          onClick={(event) => setShowBackdrop(true)}
        >
          <div className={classes.Toggler}></div>
          <div className={classes.Toggler}></div>
          <div className={classes.Toggler}></div>
        </div>

        <Row>
          <Col lg={2} className="d-none d-lg-block p-0">
            <LeftBar onlogOut={props.onlogOut} />
          </Col>
          <Col
            lg={pathname === "/Profile" ? 10 : 7}
            style={{ minHeight: "100vh" }}
          >
            {props.children}
          </Col>
          {pathname !== "/Profile" && (
            <Col lg={3} className="d-none d-lg-block p-0">
              <RightBar />
            </Col>
          )}
        </Row>
        {/* small Navigation */}

        <Drawer closeBackdrop={closeBackdrop} show={showBackdrop}>
          <RightBar />
        </Drawer>
      </Container>
      <div className={classes.SmallNavigation}>
        <SmallNavigation onlogOut={props.onlogOut} />
      </div>
    </>
  ) : (
    props.children
  );
};

export default Layout;
